/* RESPONSIBLE TEAM: team-inbox */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  attrs: {
    companies: { key: 'companies' },
  },
});
